import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import router from './router'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.http.headers.common['Authorization'] = 'Bearer c98d39b85dfa403b913383237bfb2ade25be16da10994284bd98450b328423c6b17a0465da3d4d5eb8ab7a2f3f65e3d71327dceab51948a489d593e9f6c651b9';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
